var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:({ width: _vm.percentage + '%', backgroundColor: _vm.isPausedComputed ? '#AAB2CF' : '#1CCA85' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }